import { render, staticRenderFns } from "./creative-group-tags.vue?vue&type=template&id=3889d95c&scoped=true"
import script from "./creative-group-tags.vue?vue&type=script&setup=true&lang=js"
export * from "./creative-group-tags.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creative-group-tags.vue?vue&type=style&index=0&id=3889d95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3889d95c",
  null
  
)

export default component.exports